import { compose } from 'recompose';
import PropTypes from 'prop-types';
import React, { useState } from 'react';
import EditableCard from 'modules/common/editableCard.component';
import { getClientDetails, updateClient } from 'modules/clients/clients.actions';
import { showToast } from 'modules/layout/layout.actions';
import { UPDATE_CLIENT_FAILURE } from 'modules/clients/types';
import { TOAST_MESSAGE_SEVERITY_ERROR, TOAST_MESSAGE_SEVERITY_SUCCESS } from 'modules/layout/types';
import { connect } from 'react-redux';

const TRCTeamTable = (props) => {
  
  const clientDetails = props.clientDetails;
  const hideEdit = props.hideEdit || false;
  const rawTeams = props.enumerations?.allEnums?.teams || props.enumerations?.allEnums?.Teams || [];
  const teamOptions = rawTeams
    .filter(team => team?.isActive !== false)
    .map(team => ({
      id: team.id || team.teamId || team.enumerationId,
      title: team.title || team.name || team.description
    }))
    .filter(team => team.id && team.title)
    .sort ((a, b) => a.title.localeCompare(b.title));

  const [isLoading, setIsLoading] = useState(false);

  const summaryTabs = [{ header: 'TRC Team', order: 1, iconPath: ['fas', 'people-group'] }];
  const filteredInternalUsers = props.internalUsers?.map(user => ({ id: user.internalUserId, title: `${user.firstName} ${user.lastName}` })) || [];

  const fields = [
    { header: 'Business Development', accessorKey: 'businessDevelopmentId', type: 'dropdown-v2', options: filteredInternalUsers, required: false, value: clientDetails ? clientDetails.businessDevelopmentId : '', tab: 1 },
    { header: 'Client Services Manager', accessorKey: 'clientServicesManagerId', type: 'dropdown-v2', options: filteredInternalUsers, required: false, value: clientDetails ? clientDetails.clientServicesManagerId : '', tab: 1 },
    { header: 'Client Service Specialist', accessorKey: 'clientServiceSpecialistId', type: 'dropdown-v2', options: filteredInternalUsers, required: false, value: clientDetails ? clientDetails.clientServiceSpecialistId : '', tab: 1 },
    { header: 'Client Services Executive', accessorKey: 'clientServicesExecutiveId', type: 'dropdown-v2', options: filteredInternalUsers, required: false, value: clientDetails ? clientDetails.clientServicesExecutiveId : '', tab: 1 },
    { header: 'Client Services Director', accessorKey: 'clientServicesDirectorId', type: 'dropdown-v2', options: filteredInternalUsers, required: false, value: clientDetails ? clientDetails.clientServicesDirectorId : '', tab: 1 },
    { header: 'Payroll Specialist', accessorKey: 'payrollSpecialistId', type: 'dropdown-v2', options: filteredInternalUsers, required: false, value: clientDetails ? clientDetails.payrollSpecialistId : '', tab: 1 },
    { header: 'Inventory Specialist', accessorKey: 'inventorySpecialistId', type: 'dropdown-v2', options: filteredInternalUsers, required: false, value: clientDetails ? clientDetails.inventorySpecialistId : '', tab: 1 },
    { header: 'Expense Analyst', accessorKey: 'expenseAnalystId', type: 'dropdown-v2', options: filteredInternalUsers, required: false, value: clientDetails ? clientDetails.expenseAnalystId : '', tab: 1 },
    { header: 'Service Team', accessorKey: 'teamId', type: 'dropdown-v2', options: teamOptions, required: false, value: clientDetails ? clientDetails.teamId : '', tab: 1 },
    { header: 'Service Delivery Manager', accessorKey: 'serviceDeliveryManagerId', type: 'dropdown-v2', options: filteredInternalUsers, required: false, value: clientDetails ? clientDetails.serviceDeliveryManagerId : '', tab: 1 },
    { header: 'Global Comp Analyst', accessorKey: 'globalCompAnalystId', type: 'dropdown-v2', options: filteredInternalUsers, required: false, value: clientDetails ? clientDetails.globalCompAnalystId : '', tab: 1 },
  ];

  const updateFields = async (tab, values) => {
      setIsLoading(true);
  
      let newVals = { ...clientDetails };
  
      newVals.businessDevelopmentId = values.businessDevelopmentId;
      newVals.clientServicesManagerId = values.clientServicesManagerId;
      newVals.clientServiceSpecialistId = values.clientServiceSpecialistId;
      newVals.clientServicesExecutiveId = values.clientServicesExecutiveId;
      newVals.clientServicesDirectorId = values.clientServicesDirectorId;
      newVals.payrollSpecialistId = values.payrollSpecialistId;
      newVals.inventorySpecialistId = values.inventorySpecialistId;
      newVals.expenseAnalystId = values.expenseAnalystId;
      newVals.teamId = values.teamId;
      newVals.serviceDeliveryManagerId = values.serviceDeliveryManagerId;
      newVals.globalCompAnalystId = values.globalCompAnalystId;

      const resp = await props.updateClient(newVals);
      if (resp.type === UPDATE_CLIENT_FAILURE) {
        props.showToast('Failed to update client info, please try again.', { severity: TOAST_MESSAGE_SEVERITY_ERROR });
        setIsLoading(false);
        return false;
      } else {
        await props.getClientDetails(clientDetails.clientRecordId);
        props.showToast('Client info updated successfully.', { severity: TOAST_MESSAGE_SEVERITY_SUCCESS });
        setIsLoading(false);
        return true;
      }
  };

  return (
        <EditableCard tabs={summaryTabs} summaries={fields} numColumns={3} isLoading={isLoading} hideEdit={hideEdit} updateFields={updateFields}  />
  );
};

TRCTeamTable.propTypes = {
  classes: PropTypes.object.isRequired,
  formikProps: PropTypes.object.isRequired,
  internalUsers: PropTypes.array,
};
  
export default compose(
  connect(null, {
    updateClient,
    showToast,
    getClientDetails
  })
)(TRCTeamTable);